import { Stack, Text } from '@sixui/ui';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IContentBlockTitleProps = IContainerProps & {
  children: React.ReactNode;
  icon?: React.ReactNode;
  supportingText?: React.ReactNode;
  action?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    paddingTop: '1rem',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '1rem',
    color: colorSchemeTokens.onSurface,
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
    rowGap: '1rem',
    columnGap: '2rem',
  },
  titleContainer: {
    flexGrow: 1,
  },
  icon: {
    fontSize: 18,
  },
  headline: {
    color: colorSchemeTokens.onSurfaceVariant,
  },
});

export const ContentBlockTitle: React.FC<IContentBlockTitleProps> = (props) => {
  const { sx, children, icon, supportingText, action } = props;

  return (
    <div {...stylex.props(styles.host, sx)}>
      <div {...stylex.props(styles.inner)}>
        <div {...stylex.props(styles.titleContainer)}>
          <Stack>
            <Stack horizontal gap={2}>
              {icon ? <div {...stylex.props(styles.icon)}>{icon}</div> : null}
              <Text as="h2" variant="title">
                {children}
              </Text>
            </Stack>
            {supportingText ? (
              <Text as="p" sx={styles.headline}>
                {supportingText}
              </Text>
            ) : null}
          </Stack>
        </div>

        {action}
      </div>
    </div>
  );
};
